export default __webpack_public_path__ + "static/media/Group5.7da0159a.png";